import React from "react";
import styled from "styled-components";
import { addMonths } from "date-fns";

import Header from "./components/Header";
import Footer from "./components/Footer";
import TakeawaySection from "./components/RefiBreakeven/TakeawaySection";
import SolidSeparator from "./components/RefiBreakeven/SolidSeparator";
import BreakevenAnalysis from "./components/RefiBreakeven/BreakevenAnalysis";
import LoanTermsTable from "./components/RefiBreakeven/LoanTermsTable";
import NetCostSection from "./components/RefiBreakeven/NetCostSection";

const Wrapper = styled.div`
  max-width: 612px;
  margin-left: auto;
  margin-right: auto;
`;

const RefiBreakeven = () => {
  const data1 = {};
  const data2 = {};

  const {
    efLoanAmount = 100,
    nfRate = 0.03,
    efRate = 0.08,
    nfLoanTerm = 12,
    efStartDate = new Date(),
    efLoanTerm = 180
  } = data1;

  const {
    companyPrimaryColor = "#3c4d4f",
    companySecondaryColor = "#7f322f",
    companyAccentColor = "#7f322f40",
    refiType = "Refi Breakeven",
    calculations = {}
  } = data2;

  const getEfMaturityDate = () => {
    if (efStartDate === "" || efLoanTerm === "") {
      return null;
    }

    return addMonths(efStartDate, efLoanTerm);
  };

  const {
    treasury = 0.1,
    breakevenTreasury = 0.18,
    prepaymentPenalty = 1000,
    costSavingsResult = 100,
    netCashout = 0,
    closingCosts = 0,
    newLoanAmount = 10000,
    dealName = "Default Deal"
  } = calculations;

  return (
    <Wrapper>
      <Header
        dealName={dealName}
        type="Refi Breakeven"
      />
      <TakeawaySection
        {...calculations}
        companyPrimaryColor={companyPrimaryColor}
        companySecondaryColor={companySecondaryColor}
        breakevenPercent={breakevenTreasury}
        tenYearTreasuryYield={treasury}
        refiType={refiType}
        maturityDate={getEfMaturityDate()}
      />
      <SolidSeparator companyPrimaryColor={companyPrimaryColor} />
      <div style={{ border: `0.5px solid ${companyPrimaryColor}`, margin: 12.5 }}>
        <LoanTermsTable
          companyPrimaryColor={companyPrimaryColor}
          companySecondaryColor={companySecondaryColor}
          companyAccentColor={companyAccentColor}
          efLoanAmount={efLoanAmount}
          nfLoanAmount={newLoanAmount}
          efRate={efRate}
          nfRate={nfRate}
          nfLoanTerm={nfLoanTerm}
          efStartDate={efStartDate}
          efMaturityDate={getEfMaturityDate()}
          prepaymentPenalty={prepaymentPenalty}
          closingCosts={closingCosts}
          cashOut={netCashout}
          refiType={refiType}
        />
        <NetCostSection
          companyPrimaryColor={companyPrimaryColor}
          prepaymentPenalty={prepaymentPenalty}
          interestSavings={costSavingsResult}
        />
      </div>
      <BreakevenAnalysis {...calculations} companyPrimaryColor={companyPrimaryColor} />
      <Footer />
    </Wrapper>
  );
};

export default RefiBreakeven;
